<!--  -->
<template>
  <div class="pb100">
    <banner/>
    <crumbs/>
  <div class="contain">
    <div class="confirms">
         <type-screen modelType="newlive" :menu-id="this.$route.query.columnId" @typeObj="selectType"/>
          <div class="conditioncon-1 ">
            <div class="overflowbox">
              <div class="overflowinner">
              <ul class="clearfix" @click="getSelect($event)">
                <li>
                  <a href="javascript:void(0);">状态</a>
                </li>
                <li data-code='a' class="cd selected">
                  <a href="javascript:void(0);">全部</a>
                </li>
                <li data-code='0' class="cd">
                  <a href="javascript:void(0);">预告中</a>
                </li>
                <li data-code='1' class="cd">
                  <a href="javascript:void(0);">进行中</a>
                </li>
                <li data-code='2' class="cd">
                  <a href="javascript:void(0);">已结束</a>
                </li>
              </ul>
              </div>
            </div>
          </div>
    </div>

      <ul class="newlist">
          <li v-for="(item) in dataList" :key="item.name" @click="goLinks(item)">
            <div class="imgbox">
              <img :src="getImage(item.imageUrl)" alt="">
              <div class="icon_video" v-if="item.state ==='1'"></div>
            </div>
            <h2>{{item.name}}</h2>
            <div class="date"> 时间：{{item.startTime}}</div>
            <div class="status" v-if="item.state ==='1'" :class="{going:item.state  === '1',}">进行中</div>
             <div class="status" v-if="item.state ==='2'">已结束</div>
             <div class="status" v-if="item.state ==='0'">未开始</div>
          </li>
      </ul>
       <el-pagination
         class="pagemodel1"
         layout="prev, pager, next"
        :page-size="params.limit"
        :pager-count="5"
        :total="total"
        @current-change="handleCurrentChange"
        >
  </el-pagination>
  </div>

  </div>
</template>

<script>
import typeScreen from '@/components/typescreen/index'
import crumbs from '@/components/crumbs/index'
import banner from '@/components/banner/index'
import {getNewliveList} from '@/api/newlive/index'
export default {
  name: 'newlive',
  components: {
    banner,
    crumbs,
    typeScreen
  },
  meta: {
    showHeader: true
  },
  data () {
    return {
      menuId: '',
      params: {
        pageNum: 1,
        limit: 12,
        menuId: '',
        types: null,
        liveType: null,
        unitType: null,
        state: null
      },
      dataList: [],
      total: 0
    }
  },
  created () {
    this.menuId = this.$route.query.columnId
    this.params.menuId = this.$route.query.columnId
    this.getlive()
  },
  methods: {
    getlive () {
      getNewliveList(this.params, this.menuId).then(res => {
        console.log(res, 'new')
        this.dataList = res.data.data
        this.total = res.data.totalSize
      })
    },
    getImage (val) {
      if (val === undefined) {
        return require('@/assets/common/images/default.png')
      } else {
        return val
      }
    },
    /* 筛选条件 */
    selectType (obj) {
      this.params.liveType = obj.liveType
      this.params.unitType = obj.unitType
      this.params.types = obj.customTypeId
      this.params.pageNum = 1
      this.getlive()
    },
    goLinks (item) {
      if (item.state === '1') {
        if (item.pcUrl === '' || item.pcUrl === undefined) {
          this.$message({
            message: '没有直播链接',
            type: 'warning'
          })
        } else {
          window.open(item.pcUrl)
        }
      } else if (item.state === '0') {
        this.$message({
          message: '直播还未开始',
          type: 'warning'
        })
      } else if (item.state === '2') {
        this.$confirm('直播已经结束，是否观看回放?', '', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          if (item.pcBackUrl === '' || item.pcBackUrl === undefined) {
            this.$message({
              message: '没有直播回放',
              type: 'warning'
            })
          } else {
            this.$router.push({path: '/newlivedetail',
              query: {
                columnId: item.menuId,
                id: item.id
              }
            })
            // window.open(item.pcBackUrl)
          }
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          })
        })
      }
    },
    handleCurrentChange (val) {
      this.params.pageNum = val
      this.getlive()
    },
    getSelect (e) {
      let code = e.target.parentNode.getAttribute('data-code')
      console.log(e.target.parentNode.parentNode.childNodes)
      let childs = e.target.parentNode.parentNode.childNodes
      for (var i = 0; i < childs.length; i++) {
        if (childs[i].nodeName === 'LI') {
          childs[i].classList.remove('selected')
          console.log(childs[i].classList)
        }
      }
      e.target.parentNode.classList.add('selected')
      if (code === '0') {
        this.params.state = 0
      } else if (code === '1') {
        this.params.state = 1
      } else if (code === '2') {
        this.params.state = 2
      } else if (code === 'a') {
        this.params.state = null
      }
      this.getlive()
    }
  },
  beforeDestroy () {

  }
}

</script>

<style lang='scss' scoped>
@import '../../assets/common/scss/newLive.scss';
.confirms {
  margin: 20px 0;
  padding: 15px;
  &>>>.conditioncon-1{
    margin: 0;
    padding: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/newlive/list.vue